/**
 * Builds a user-visible error string from an axios error.
 * For 422, appends Laravel validation messages from `errors` so the toast is specific.
 */
export function formatApiError(error, fallback) {
  if (!error || !error.response) {
    return (error && error.message) || fallback;
  }
  const { status, data } = error.response;
  if (!data || typeof data !== 'object') {
    return fallback;
  }
  const base = data.message || fallback;
  if (status === 422 && data.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
    const detailParts = [];
    Object.keys(data.errors).forEach((field) => {
      const msgs = data.errors[field];
      if (Array.isArray(msgs)) {
        msgs.forEach((m) => {
          if (m) detailParts.push(String(m).trim());
        });
      } else if (msgs) {
        detailParts.push(String(msgs).trim());
      }
    });
    if (detailParts.length > 0) {
      return `${base} ${detailParts.join(' ')}`.trim();
    }
  }
  // Laravel validation uses `message`; duplicate crawl (409) uses `error` only.
  return data.message || data.error || fallback;
}
